import { toDateTimeString } from "utils/DateFormatter/toDateTimeString";

export const nullableDateTimeToString = (date: string | null | undefined) => {
  if (!date) return "-";
  let dateString = toDateTimeString(date);
  if (dateString === "Invalid Date") dateString += " - " + date;
  return dateString;
};
